import axiosInstance from "../API/axiosInstance";


export const getEventSessions = async (id) => {
    const { data } = await axiosInstance.get(`/get_sessions/${id}`);
    return data;
};

export const getMyLiveSessions = async () => {
    const { data } = await axiosInstance.get("/my-live-sessions");
    return data;
};

export const getSessionsWithMeetingStatus = async (id) => {
    const { data } = await axiosInstance.get(`/events/${id}/sessions/with-meeting`);
    return data;
};
export const getSessionTables = async (id) => {
    const { data } = await axiosInstance.get(`/sessions/${id}/tables`);
    return data;
};
export const getTableParticipants = async (sessionId, tableId) => {
    const { data } = await axiosInstance.get(`/sessions/${sessionId}/tables/${tableId}/participants`);
    return data;
};
export const joinSessionTable = async (sessionId, tableId, body = {}) => {
    const { data } = await axiosInstance.post(
        `/sessions/${sessionId}/tables/${tableId}/join`,
        body
    );
    return data;
};
export const switchTable = async (sessionId, newTableId) => {
    const { data } = await axiosInstance.post(`/sessions/${sessionId}/tables/${newTableId}/switch`);
    return data;
}
export const leaveSessionTable = async (sessionId) => {
    const { data } = await axiosInstance.post(`/sessions/${sessionId}/leave`);
    return data;
};
export const startBroadcast = async (sessionId) => {
    const { data } = await axiosInstance.post(`/sessions/${sessionId}/broadcast/start`);
    return data;
};
export const stopBroadcast = async (sessionId) => {
    const { data } = await axiosInstance.post(`/sessions/${sessionId}/broadcast/stop`);
    return data;
};
export const getBroadcastToken = async (sessionId) => {
    const { data } = await axiosInstance.get(`/sessions/${sessionId}/broadcast/token`);
    return data;
};
export const getBroadcastStatus = async (sessionId) => {
    const { data } = await axiosInstance.get(`/sessions/${sessionId}/broadcast/status`);
    return data;
};
export const getViewerBroadcastToken = async (sessionId) => {
    const { data } = await axiosInstance.get(`/sessions/${sessionId}/broadcast/viewer-token`);
    return data;
};
export const updateNetworkingStatus = async (sessionId, networkingData) => {
    const { data } = await axiosInstance.put(`/sessions/${sessionId}/table/networking`, networkingData);
    return data;
};

export const joinGuestToSession = async (sessionId, payload) => {
    const { data } = await axiosInstance.post(
        `/events/session/${sessionId}/join-guest`,
        payload,
        {
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        }
    );

    return data;
};

export const postMeetingNotes = async (sessionId, payload) => {
    const { data } = await axiosInstance.post(
        `/sessions/${sessionId}/notes`,
        payload);
    return data;
};

export const getMeetingNotes = async (sessionId) => {
    const { data } = await axiosInstance.get(`/sessions/${sessionId}/notes`);
    return data;
};

export const leaveSessionTableKeepalive = (sessionId) => {
    try {
        const token = localStorage.getItem("authToken");
        const baseURL = axiosInstance.defaults.baseURL || "";
        const url = `${String(baseURL).replace(/\/$/, "")}/sessions/${sessionId}/leave`;

        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `${token}` } : {}),
                userType: "User",
            },
            // no body required for your endpoint
            keepalive: true,
        });
    } catch {
        // ignore - browser is closing
    }
};